import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/11d6HojVpesPVMymSbYhnJ/Valuan_Logos_Blanco_sin_fondo-14.png';
type LogoVariant = 'full' | 'small';
type LogoTheme = 'light' | 'dark';
interface ValuanLogoProps {
  variant?: LogoVariant;
  theme?: LogoTheme;
  className?: string;
}
export function ValuanLogo({
  variant = 'full',
  theme = 'light',
  className = ''
}: ValuanLogoProps) {
  const height = variant === 'small' ? 'h-7' : 'h-9';
  return <img src={LOGO_URL} alt="Valuan CRM" className={`${height} w-auto object-contain mx-auto ${theme === 'dark' ? 'brightness-0 invert' : ''} ${className}`} data-id="element-224" />;
}